<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useSessionStore } from '@/application/auth'
import { PToast } from '@/design-system'
import PAppShell from '@/presentation/components/PAppShell.vue'
import { useRoute } from 'vue-router'

/**
 * Root applicatif. Sprint 8-D ajoute le PAppShell pour les pages
 * authentifiées (dashboard + admin CRUD). On garde un mode "standalone"
 * pour les routes publiques (login, showcase) qui ont leur propre layout
 * pleine-page.
 *
 * Comportement :
 *   - route publique (meta.public === true) → router-view nu
 *   - route authentifiée → router-view dans PAppShell (sidebar + main)
 *
 * Toast container PRoster monté à la racine (out-of-flow).
 */
const route = useRoute()
const sessionStore = useSessionStore()
const { isAuthenticated } = storeToRefs(sessionStore)
</script>

<template>
    <PAppShell v-if="isAuthenticated && !route.meta?.public" />
    <router-view v-else />
    <PToast />
</template>
